export default {
  API_URL: 'http://admin.centerartsdesign.org',
  LOCAL_API_URL: 'http://localhost:1337'
}
